import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "gb8ke04r",
  dataset: "production",
  apiVersion: "2021-03-25",
  useCdn: true,
});
